(function() {
  var SECTION_SELECTOR = '[data-section-id][id^="product-details-section-"]';
  var CONFIG_SELECTOR = 'script[data-product-details-config]';
  var initializedSections = new Set();

  function formatPrice(value) {
    return String(value).replace('.', ',');
  }

  function formatGreenleazePrice(value) {
    return Number(value).toFixed(2).replace('.', ',');
  }

  function updateStickyPrice(stickyPriceNode, price) {
    if (!stickyPriceNode) {
      return;
    }

    var formattedPrice = formatPrice(price);
    var parts = formattedPrice.split(',');

    stickyPriceNode.setAttribute('data-int', parts[0]);
    stickyPriceNode.setAttribute('data-dec', parts[1] || '00');
    stickyPriceNode.textContent = formattedPrice;
  }

  function parseConfig(sectionRoot) {
    var sectionId = sectionRoot.dataset.sectionId;
    var configNode = document.querySelector(
      CONFIG_SELECTOR + '[data-product-details-config="' + sectionId + '"]',
    );

    if (!configNode) {
      return null;
    }

    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      console.error('Unable to parse product details config', error);
      return null;
    }
  }

  function getElements(sectionRoot, sectionId) {
    var stickyBar = document.querySelector('.sticky-bar[data-section-id="' + sectionId + '"]');

    return {
      sectionRoot: sectionRoot,
      stickyBar: stickyBar,
      gallerySlides: Array.from(sectionRoot.querySelectorAll('.product-gallery__main-img')),
      thumbnails: Array.from(sectionRoot.querySelectorAll('.product-gallery__thumb')),
      tabButtons: Array.from(sectionRoot.querySelectorAll('.product-tabs__btn')),
      tabPanes: Array.from(sectionRoot.querySelectorAll('.product-tabs__pane')),
      variantIdInput: sectionRoot.querySelector('#product-variant-id'),
      productForm: sectionRoot.querySelector('#product-form-details'),
      variantRadios: Array.from(sectionRoot.querySelectorAll('.variant-option')),
      selectedOptionDisplays: Array.from(sectionRoot.querySelectorAll('[id^="selected-option-"]')),
      subscriptionCardsContainer: sectionRoot.querySelector('#subscription-cards'),
      addToCartButton: sectionRoot.querySelector('#product-add-to-cart'),
      addToCartButtonLabel: sectionRoot.querySelector('#product-add-to-cart-label'),
      ctaPriceLabel: sectionRoot.querySelector('#cta-price-label'),
      ctaPriceAmount: sectionRoot.querySelector('#cta-price-amount'),
      ctaPriceSub: sectionRoot.querySelector('#cta-price-sub'),
      greenleazeError: sectionRoot.querySelector('#greenleaze-error'),
      stickyVariantLabel: stickyBar ? stickyBar.querySelector('#sticky-variant-label') : null,
      stickyBarPrice: stickyBar ? stickyBar.querySelector('#sticky-bar-price') : null,
      stickyBarPlanInfo: stickyBar ? stickyBar.querySelector('#sticky-bar-plan-info') : null,
      stickyBarCta: stickyBar ? stickyBar.querySelector('#sticky-bar-cta') : null,
      stickyBarCtaLabel: stickyBar ? stickyBar.querySelector('#sticky-bar-cta-label') : null,
    };
  }

  function createStore(config, elements) {
    return {
      config: config,
      elements: elements,
      variants: Array.isArray(config.variants) ? config.variants : [],
      currentVariant: null,
      selectedDuration: null,
      greenleazePrices: null,
      observer: null,
    };
  }

  function findVariantById(store, variantId) {
    return (
      store.variants.find(function(variant) {
        return String(variant.id) === String(variantId);
      }) || null
    );
  }

  function findSelectedVariant(store) {
    var selectedOptions = [];

    for (var index = 1; index <= store.config.optionCount; index += 1) {
      var checkedOption = store.elements.sectionRoot.querySelector(
        '.variant-option[data-option-position="' + index + '"]:checked',
      );

      if (!checkedOption) {
        return null;
      }

      selectedOptions.push(checkedOption.value);
    }

    return (
      store.variants.find(function(variant) {
        return selectedOptions.every(function(optionValue, optionIndex) {
          return variant.options[optionIndex] === optionValue;
        });
      }) || null
    );
  }

  function isVariantBuyable(variant) {
    if (!variant || !variant.available) {
      return false;
    }
    if (
      variant.inventory_management &&
      variant.inventory_quantity <= 0 &&
      variant.inventory_policy !== 'continue'
    ) {
      return false;
    }
    return true;
  }

  function updateOptionAvailability(store) {
    var selectedValues = [];

    for (var index = 1; index <= store.config.optionCount; index += 1) {
      var checked = store.elements.sectionRoot.querySelector(
        '.variant-option[data-option-position="' + index + '"]:checked',
      );
      selectedValues.push(checked ? checked.value : null);
    }

    store.elements.variantRadios.forEach(function(radio) {
      var position = parseInt(radio.dataset.optionPosition, 10);
      var optionIndex = position - 1;
      var value = radio.value;

      var hasAvailableMatch = store.variants.some(function(variant) {
        if (!isVariantBuyable(variant)) {
          return false;
        }
        if (variant.options[optionIndex] !== value) {
          return false;
        }
        return selectedValues.every(function(selected, otherIndex) {
          if (otherIndex === optionIndex || selected === null) {
            return true;
          }
          return variant.options[otherIndex] === selected;
        });
      });

      var label = store.elements.sectionRoot.querySelector('label[for="' + radio.id + '"]');

      radio.disabled = !hasAvailableMatch;

      if (label) {
        label.classList.toggle('is-unavailable', !hasAvailableMatch);
      }
    });
  }

  function updateSelectedOptionLabels(store) {
    store.elements.variantRadios.forEach(function(radio) {
      if (!radio.checked) {
        return;
      }

      var optionPosition = radio.dataset.optionPosition;
      var display = store.elements.sectionRoot.querySelector('#selected-option-' + optionPosition);

      if (display) {
        display.textContent = radio.value;
      }
    });
  }

  function updateBrowserUrl(variant) {
    if (!variant || !window.history || !window.history.replaceState) {
      return;
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({ path: url.toString() }, '', url.toString());
  }

  function updateActionButtons(store) {
    var variant = store.currentVariant;
    var addToCartButton = store.elements.addToCartButton;
    var addToCartButtonLabel = store.elements.addToCartButtonLabel;
    var stickyBarCta = store.elements.stickyBarCta;
    var stickyBarCtaLabel = store.elements.stickyBarCtaLabel;

    if (!variant) {
      return;
    }

    if (store.elements.variantIdInput) {
      store.elements.variantIdInput.value = variant.id;
    }

    if (addToCartButton) {
      addToCartButton.disabled = !variant.available;
    }

    if (stickyBarCta) {
      stickyBarCta.disabled = !variant.available;
      stickyBarCta.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
    }

    if (!variant.available) {
      if (addToCartButtonLabel) {
        addToCartButtonLabel.textContent = addToCartButton.dataset.labelUnavailable;
      }

      if (stickyBarCtaLabel) {
        stickyBarCtaLabel.textContent = addToCartButton.dataset.labelUnavailable;
      }

      return;
    }

    if (store.config.greenleazeEnabled && store.selectedDuration && store.greenleazePrices) {
      updateGreenleazeSummary(store, store.selectedDuration);
      return;
    }

    if (addToCartButtonLabel) {
      addToCartButtonLabel.textContent = store.config.greenleazeEnabled
        ? addToCartButton.dataset.greenleazeLabel
        : addToCartButton.dataset.labelAvailable;
    }

    if (stickyBarCtaLabel) {
      stickyBarCtaLabel.textContent = store.config.greenleazeEnabled
        ? addToCartButton.dataset.greenleazeLabel
        : addToCartButton.dataset.labelAvailable;
    }
  }

  function updateStandardSummary(store, card) {
    if (!card) {
      return;
    }

    var price = card.dataset.price;
    var fee = card.dataset.fee;
    var duration = card.dataset.duration;

    if (store.elements.ctaPriceLabel) {
      store.elements.ctaPriceLabel.textContent = 'Votre abonnement';
    }

    if (store.elements.ctaPriceAmount) {
      store.elements.ctaPriceAmount.textContent = formatPrice(price) + ' € / mois';
    }

    if (store.elements.ctaPriceSub) {
      store.elements.ctaPriceSub.textContent =
        'Abonnement ' + duration + ' mois · Adhésion : ' + formatPrice(fee) + ' €';
    }

    updateStickyPrice(store.elements.stickyBarPrice, price);

    if (store.elements.stickyBarPlanInfo) {
      store.elements.stickyBarPlanInfo.textContent =
        'Adhésion\u00a0: ' + formatPrice(fee) + '\u00a0€ · ' + duration + ' mois';
    }
  }

  function selectSubscriptionCard(store, card) {
    if (!card) {
      return;
    }

    var cards = Array.from(
      store.elements.subscriptionCardsContainer.querySelectorAll('.subscription-card'),
    );

    cards.forEach(function(currentCard) {
      var isSelected = currentCard === card;
      currentCard.classList.toggle('is-selected', isSelected);
      currentCard.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (store.config.greenleazeEnabled) {
      updateGreenleazeSummary(store, card.dataset.duration);
    } else {
      updateStandardSummary(store, card);
    }
  }

  function bindSubscriptionCard(store, card) {
    card.addEventListener('click', function() {
      selectSubscriptionCard(store, card);
    });

    card.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      selectSubscriptionCard(store, card);
    });
  }

  function activateMedia(store, mediaId) {
    if (!mediaId) {
      return;
    }

    var idStr = String(mediaId);
    var matched = false;

    store.elements.gallerySlides.forEach(function(slide) {
      var isMatch = slide.dataset.mediaId === idStr;
      slide.classList.toggle('is-active', isMatch);
      if (isMatch) {
        matched = true;
      }
    });

    if (!matched) {
      return;
    }

    store.elements.thumbnails.forEach(function(thumb) {
      thumb.classList.toggle('is-active', thumb.dataset.mediaId === idStr);
    });
  }

  function bindGallery(store) {
    store.elements.thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        activateMedia(store, thumb.dataset.mediaId);
      });
    });
  }

  function bindDescriptionToggle(store) {
    var descriptions = store.elements.sectionRoot.querySelectorAll('[data-product-description]');

    descriptions.forEach(function(description) {
      var content = description.querySelector('[data-product-description-content]');
      var toggle = description.querySelector('[data-product-description-toggle]');

      if (!content || !toggle) {
        return;
      }

      var isOverflowing = content.scrollHeight > content.clientHeight + 1;

      if (!isOverflowing) {
        toggle.style.display = 'none';
        return;
      }

      toggle.addEventListener('click', function() {
        var expanded = description.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }

  function bindTabs(store) {
    store.elements.tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var targetPane = store.elements.sectionRoot.querySelector('#tab-' + button.dataset.tab);

        store.elements.tabButtons.forEach(function(currentButton) {
          currentButton.classList.remove('is-active');
          currentButton.setAttribute('aria-selected', 'false');
        });

        store.elements.tabPanes.forEach(function(pane) {
          pane.classList.remove('is-active');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');

        if (targetPane) {
          targetPane.classList.add('is-active');
        }
      });
    });
  }

  function syncVariant(store) {
    var selectedVariant = findSelectedVariant(store);

    if (!selectedVariant) {
      return;
    }

    store.currentVariant = selectedVariant;

    updateSelectedOptionLabels(store);
    updateOptionAvailability(store);

    var buyable = isVariantBuyable(selectedVariant) && store.config.rentalAvailable !== false;
    var availabilityArea = store.elements.sectionRoot.querySelector('.product-availability-area');
    if (availabilityArea) {
      availabilityArea.dataset.variantBuyable = buyable ? 'true' : 'false';
    }
    if (store.elements.stickyBar) {
      store.elements.stickyBar.dataset.variantBuyable = buyable ? 'true' : 'false';
    }

    if (selectedVariant.featured_media && selectedVariant.featured_media.id) {
      activateMedia(store, selectedVariant.featured_media.id);
    }

    if (store.elements.stickyVariantLabel) {
      store.elements.stickyVariantLabel.textContent = selectedVariant.title;
    }

    updateActionButtons(store);
    updateBrowserUrl(selectedVariant);

    window.dispatchEvent(
      new CustomEvent('product:change', {
        detail: {
          sectionId: store.config.sectionId,
          variant: selectedVariant,
        },
      }),
    );
  }

  function bindVariants(store) {
    store.elements.variantRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        syncVariant(store);
      });
    });

    store.currentVariant =
      findVariantById(store, store.config.currentVariantId) || findSelectedVariant(store);

    syncVariant(store);
  }

  function setStickyBarVisibility(store, isVisible) {
    if (!store.elements.stickyBar) {
      return;
    }

    store.elements.stickyBar.classList.toggle('is-visible', isVisible);

    if (isVisible) {
      store.elements.stickyBar.removeAttribute('aria-hidden');
    } else {
      store.elements.stickyBar.setAttribute('aria-hidden', 'true');
    }
  }

  function bindStickyBar(store) {
    var productCta = store.elements.addToCartButton;

    if (store.elements.stickyBarCta) {
      store.elements.stickyBarCta.addEventListener('click', function(event) {
        event.preventDefault();
        triggerPrimaryAction(store);
      });
    }

    if (!store.elements.stickyBar || !productCta) {
      return;
    }

    if (store.config.greenleazeEnabled) {
      setStickyBarVisibility(store, true);
      return;
    }

    store.observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          setStickyBarVisibility(store, !entry.isIntersecting);
        });
      },
      { threshold: 0.3 },
    );

    store.observer.observe(productCta);
  }

  function setGreenleazeError(store, message) {
    if (store.elements.greenleazeError) {
      store.elements.greenleazeError.textContent = message || '';
    }
  }

  function updateGreenleazeSummary(store, duration) {
    if (!store.greenleazePrices || !store.greenleazePrices[duration]) {
      return;
    }

    var pricing = store.greenleazePrices[duration];
    var monthlyPriceLabel = 'Louer pour ' + formatGreenleazePrice(pricing.monthly) + ' € / mois';

    store.selectedDuration = String(duration);

    if (store.elements.ctaPriceLabel) {
      store.elements.ctaPriceLabel.textContent = 'Location';
    }

    if (store.elements.ctaPriceAmount) {
      store.elements.ctaPriceAmount.textContent =
        formatGreenleazePrice(pricing.monthly) + ' € / mois';
    }

    if (store.elements.ctaPriceSub) {
      store.elements.ctaPriceSub.textContent =
        store.selectedDuration +
        ' mois · Apport : ' +
        formatGreenleazePrice(pricing.initial) +
        ' €';
    }

    updateStickyPrice(store.elements.stickyBarPrice, formatGreenleazePrice(pricing.monthly));

    if (store.elements.stickyBarPlanInfo) {
      store.elements.stickyBarPlanInfo.textContent =
        'Apport : ' +
        formatGreenleazePrice(pricing.initial) +
        ' € · ' +
        store.selectedDuration +
        ' mois';
    }

    if (store.currentVariant && store.currentVariant.available) {
      if (store.elements.addToCartButtonLabel) {
        store.elements.addToCartButtonLabel.textContent = monthlyPriceLabel;
      }

      if (store.elements.stickyBarCtaLabel) {
        store.elements.stickyBarCtaLabel.textContent = monthlyPriceLabel;
      }
    }
  }

  function createGreenleazeCard(duration, pricing, badgeConfig, isSelected) {
    var card = document.createElement('div');
    var priceNode = document.createElement('div');
    var priceUnitNode = document.createElement('div');
    var durationNode = document.createElement('div');
    var feeNode = document.createElement('div');

    card.className = 'subscription-card';
    if (badgeConfig.isPopular) {
      card.classList.add('is-popular');
    }
    if (isSelected) {
      card.classList.add('is-selected');
    }

    card.dataset.duration = duration;
    card.dataset.price = Number(pricing.monthly).toFixed(2);
    card.dataset.fee = Number(pricing.initial).toFixed(2);
    card.dataset.isPopular = badgeConfig.isPopular ? 'true' : 'false';
    card.dataset.badge = badgeConfig.badge;
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

    if (badgeConfig.badge) {
      var badgeNode = document.createElement('div');
      badgeNode.className = 'subscription-card__badge';
      badgeNode.textContent = badgeConfig.badge;
      card.appendChild(badgeNode);
    }

    priceNode.className = 'subscription-card__price';
    priceNode.textContent = formatGreenleazePrice(pricing.monthly) + ' €';

    priceUnitNode.className = 'subscription-card__price-unit';
    priceUnitNode.textContent = '/ mois';
    priceNode.appendChild(priceUnitNode);

    durationNode.className = 'subscription-card__duration';
    durationNode.textContent = 'Abonnement ' + duration + ' mois';

    feeNode.className = 'subscription-card__fee';
    feeNode.textContent =
      "frais d'adhésion de " + formatGreenleazePrice(pricing.initial) + ' €';

    card.appendChild(priceNode);
    card.appendChild(durationNode);
    card.appendChild(feeNode);

    return card;
  }

  function renderGreenleazeCards(store, pricesForProduct) {
    var cardsContainer = store.elements.subscriptionCardsContainer;

    if (!cardsContainer) {
      return;
    }

    var existingCards = Array.from(cardsContainer.querySelectorAll('.subscription-card'));
    var badgesByDuration = {};
    var durationKeys = Object.keys(pricesForProduct).sort(function(a, b) {
      return Number(a) - Number(b);
    });

    existingCards.forEach(function(card) {
      badgesByDuration[String(card.dataset.duration)] = {
        badge: card.dataset.badge || '',
        isPopular: card.dataset.isPopular === 'true',
      };
    });

    cardsContainer.innerHTML = '';

    durationKeys.forEach(function(duration, index) {
      var badgeConfig = badgesByDuration[String(duration)] || { badge: '', isPopular: false };
      var isSelected = index === durationKeys.length - 1;
      var card = createGreenleazeCard(duration, pricesForProduct[duration], badgeConfig, isSelected);

      bindSubscriptionCard(store, card);
      cardsContainer.appendChild(card);
    });

    if (durationKeys.length) {
      updateGreenleazeSummary(store, durationKeys[durationKeys.length - 1]);
    }
  }

  function getCurrentGreenleazeVariant(store) {
    if (store.elements.variantIdInput && store.elements.variantIdInput.value) {
      return findVariantById(store, store.elements.variantIdInput.value) || store.currentVariant;
    }

    return store.currentVariant;
  }

  function setGreenleazeLoading(store, isLoading) {
    var loaderOverlay = document.getElementById('greenleaze-fullscreen-loader');
    if (loaderOverlay) {
      loaderOverlay.classList.toggle('is-active', isLoading);
    }

    if (!store.elements.addToCartButton) {
      return;
    }

    store.elements.addToCartButton.disabled = isLoading;
    store.elements.addToCartButton.classList.toggle('button--loading', isLoading);

    if (isLoading && store.elements.addToCartButtonLabel) {
      store.elements.addToCartButtonLabel.textContent =
        store.elements.addToCartButton.dataset.greenleazeLoadingLabel || 'Chargement...';
    } else {
      updateActionButtons(store);
    }
  }

  function submitGreenleaze(store) {
    var selectedVariant = getCurrentGreenleazeVariant(store);
    var duration = store.selectedDuration;

    if (!selectedVariant) {
      setGreenleazeError(store, 'Veuillez choisir une variante valide.');
      return;
    }

    if (!selectedVariant.available) {
      setGreenleazeError(store, 'Cette variante est indisponible.');
      return;
    }

    if (!duration) {
      setGreenleazeError(store, 'Veuillez choisir une durée de location.');
      return;
    }

    if (typeof window.sendCartAndRedirect !== 'function') {
      setGreenleazeError(
        store,
        'Le service de location est temporairement indisponible.',
      );
      return;
    }

    setGreenleazeError(store, '');
    setGreenleazeLoading(store, true);

    var pdistinctId =
      window.ShopifyAnalytics?.lib?.user?.()?.traits?.()?.uniqToken ||
      window.greenleaze_tracking ||
      null;

    Promise.resolve(window.sendCartAndRedirect(duration, selectedVariant.id, pdistinctId)).finally(
      function() {
        window.setTimeout(function() {
          setGreenleazeLoading(store, false);
        }, 300);
      },
    );
  }

  function refreshGreenleazeProduct(store) {
    if (
      !window.initPriceGreenleaze ||
      typeof window.getAllPricesForProduct !== 'function' ||
      !store.currentVariant
    ) {
      return;
    }

    var pricesForProduct = window.getAllPricesForProduct((store.currentVariant.price / 1.2) / 100);

    if (!pricesForProduct) {
      return;
    }

    store.greenleazePrices = pricesForProduct;
    renderGreenleazeCards(store, pricesForProduct);
  }

  function bindGreenleaze(store) {
    if (!store.config.greenleazeEnabled) {
      Array.from(
        store.elements.subscriptionCardsContainer.querySelectorAll('.subscription-card'),
      ).forEach(function(card) {
        bindSubscriptionCard(store, card);
      });

      var initialCard = store.elements.subscriptionCardsContainer.querySelector(
        '.subscription-card.is-selected',
      ) || store.elements.subscriptionCardsContainer.querySelector('.subscription-card');

      if (initialCard) {
        updateStandardSummary(store, initialCard);
      }

      return;
    }

    var onGreenleazeRefresh = function() {
      refreshGreenleazeProduct(store);
    };

    var onWindowMessage = function(event) {
      if (event.data?.type !== 'greenleazeError') {
        return;
      }

      setGreenleazeLoading(store, false);
      setGreenleazeError(store, event.data.message || 'Une erreur s\'est produite.');
    };

    if (store.elements.addToCartButton) {
      store.elements.addToCartButton.addEventListener('click', function(event) {
        event.preventDefault();
        submitGreenleaze(store);
      });
    }

    window.addEventListener('greenleazePriceActualize', onGreenleazeRefresh);
    window.addEventListener('message', onWindowMessage);
    window.addEventListener('product:change', function(event) {
      if (event.detail?.sectionId !== store.config.sectionId) {
        return;
      }

      refreshGreenleazeProduct(store);
    });

    if (window.initPriceGreenleaze && typeof window.getAllPricesForProduct === 'function') {
      refreshGreenleazeProduct(store);
    }
  }

  function triggerPrimaryAction(store) {
    if (!store.elements.addToCartButton || store.elements.addToCartButton.disabled) {
      return;
    }

    if (store.config.greenleazeEnabled) {
      submitGreenleaze(store);
      return;
    }

    if (!store.elements.productForm || store.elements.productForm.tagName !== 'FORM') {
      return;
    }

    if (typeof store.elements.productForm.requestSubmit === 'function') {
      store.elements.productForm.requestSubmit();
      return;
    }

    var submitEvent = new Event('submit', { bubbles: true, cancelable: true });

    if (store.elements.productForm.dispatchEvent(submitEvent)) {
      store.elements.productForm.submit();
    }
  }

  function initSection(sectionRoot) {
    var sectionId = sectionRoot.dataset.sectionId;

    if (!sectionId || initializedSections.has(sectionId)) {
      return;
    }

    var config = parseConfig(sectionRoot);

    if (!config) {
      return;
    }

    var store = createStore(config, getElements(sectionRoot, sectionId));

    initializedSections.add(sectionId);

    bindGallery(store);
    bindTabs(store);
    bindDescriptionToggle(store);
    bindVariants(store);
    bindStickyBar(store);
    bindGreenleaze(store);
  }

  function initAllSections(scope) {
    var root = scope || document;

    root.querySelectorAll(SECTION_SELECTOR).forEach(function(sectionRoot) {
      initSection(sectionRoot);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAllSections(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAllSections(event.target);
  });
})();
